import {
  IButton,
} from "../../../panes";

// vueのscript内のクラスのstaticフィールドに持ってたが、tsファイルから参照すると、VSCODE上でエラーが出る.
// (DocumentViewerMenuの型が認識されずに、VueConstructor<Vue>と認識されてる.vue-loaderのせい？)
// TODO: できれば見直し.型定義とか.
export class DocumentViewerMenuButtons {
  static readonly print: IButton = {
    name: "印刷",
    description: "表示中の文書の印刷プレビューを表示します。",
    iconClass: "print",
  };
  static readonly printToSelectedPrinter: IButton = {
    name: "印刷(選択)",
    description: "表示中の文書を出力先を選んで印刷します。(登録はされません。)",
    iconClass: "select-and-print",
  };
  static readonly editNewQuotedDocument: IButton = {
    name: "引用転記",
    description: "表示中の文書を引用した新規文書を作成します。",
    iconClass: "quote-and-edit",
  };
  static readonly editNote: IButton = {
    name: "文書メモ",
    description: "表示中の文書の文書メモを編集します。",
    iconClass: "document",
  };
}
